import { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { Copy, Share2, QrCode, Send, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { referralLink } from "@/lib/branch";

export const ShareLinks = ({ code, compact = false }) => {
  const [qr, setQr] = useState(false);
  const link = referralLink(code);
  const text = encodeURIComponent(`Join me on EverGro eMart: ${link}`);
  const copy = async () => { await navigator.clipboard.writeText(link); toast.success("Referral link copied"); };
  const native = async () => {
    if (navigator.share) { try { await navigator.share({ title: "EverGro eMart", url: link }); } catch { /* user closed */ } }
    else copy();
  };
  const btn = "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold border transition-colors";

  return (
    <div className="space-y-2" data-testid={`share-links-${code}`}>
      {!compact && <div className="bg-[#F8FAFC] border border-[#E2E8F0] rounded-xl px-3 py-2 font-mono text-xs break-all" data-testid={`share-link-text-${code}`}>{link}</div>}
      <div className="flex flex-wrap gap-2">
        <button onClick={copy} className={`${btn} border-[#FECACA] text-[#7F1D1D] hover:bg-[#FEE2E2]`} data-testid={`share-copy-${code}`}><Copy className="w-3.5 h-3.5" /> Copy</button>
        <a href={`https://wa.me/?text=${text}`} target="_blank" rel="noreferrer" className={`${btn} border-emerald-200 text-emerald-700 hover:bg-emerald-50`} data-testid={`share-whatsapp-${code}`}><MessageCircle className="w-3.5 h-3.5" /> WhatsApp</a>
        <a href={`https://t.me/share/url?url=${encodeURIComponent(link)}&text=${encodeURIComponent("Join me on EverGro eMart")}`} target="_blank" rel="noreferrer" className={`${btn} border-sky-200 text-sky-700 hover:bg-sky-50`} data-testid={`share-telegram-${code}`}><Send className="w-3.5 h-3.5" /> Telegram</a>
        <button onClick={() => setQr(true)} className={`${btn} border-[#E2E8F0] text-[#334155] hover:bg-[#F1F5F9]`} data-testid={`share-qr-${code}`}><QrCode className="w-3.5 h-3.5" /> QR</button>
        <button onClick={native} className={`${btn} border-[#DC2626] bg-[#DC2626] text-white hover:bg-[#B91C1C]`} data-testid={`share-native-${code}`}><Share2 className="w-3.5 h-3.5" /> Share</button>
      </div>
      <Dialog open={qr} onOpenChange={setQr}>
        <DialogContent className="max-w-sm">
          <DialogHeader><DialogTitle>Scan to join via {code}</DialogTitle></DialogHeader>
          <div className="flex justify-center p-4" data-testid={`share-qr-dialog-${code}`}><QRCodeSVG value={link} size={220} fgColor="#7F1D1D" /></div>
        </DialogContent>
      </Dialog>
    </div>
  );
};
